module.exports = __webpack_public_path__ + "img/shape-002.12e87653.svg";